import { useSelector } from 'react-redux';
import { selectUserIsRunwayAdmin } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';

const useIsRunwayAdmin: () => boolean = () => {
    const isRunwayAdmin = useSelector((state: RootState) => selectUserIsRunwayAdmin(state));

    return isRunwayAdmin;
};

export default useIsRunwayAdmin;
